import produce from "immer";
import { CartState } from "../";

export interface SetDisabledCartAction {
  disabled: boolean;
  type: "setDisabledCart";
}

export const setDisabledCart = (state: CartState, action: SetDisabledCartAction): CartState => {
  return produce(state, (draftState) => {
    draftState.ui.disabled = action.disabled;
  });
};
